import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
// import twlocale from 'moment/locale/zh-tw';

const momentConfig = {};
// moment.locale('zh-tw', twlocale);
// react native 會一直要求使用下面者個method才對，不然會一直跳 warning
moment.updateLocale('zh-tw', momentConfig);

export default class TimeFormat extends PureComponent {
  static propTypes = {
    time: PropTypes.number.isRequired,
    format: PropTypes.string
  };

  static defaultProps = {
    format: 'timeAgo'
  };

  constructor(props) {
    super(props);
    this.formatTime = this.formatTime.bind(this);
  }

  formatTime() {
    const time = this.props.time;
    const aDay = 86400000, date = new Date(time), now = new Date();
    switch (this.props.format) {
      case 'timeAgo': {
        if (date.getFullYear() === now.getFullYear()) {
          if (now.getTime() - date.getTime() >= aDay) {
            return moment(time).format('L');
          } else {
            return moment(time).fromNow();
          }
        } else {
          return moment(time).format('LL');
        }
      }
      case 'simpleTimeAgo': {
        if(date.getFullYear() === now.getFullYear()){
            if (now.getTime() - date.getTime() >= aDay) {
                return moment(time).format('YYYY-MM-DD');
            } else{
                return moment(time).fromNow();
            }
        } else{
            return moment(time).format('YYYY-MM-DD');
        }
      }
      case 'simpleTime': {
        return moment(time).format('YYYY/MM/DD');
      }
      case 'simpleFullTime': {
        return moment(time).format('YYYY/MM/DD hh:mm');
      }
      case 'shortDate': {
        return moment(time).format('YY/MM/DD');
      }
      default: 
        return "";
    }
  }

  render() {
    const formatted = this.formatTime();
    return <span>{formatted}</span>;
  }
}



// WEBPACK FOOTER //
// ./src/components/commons/TimeFormat.jsx